import React from "react";
import Typography from "@mui/material/Typography";
import {Stack} from "@mui/material";
import {SquareThumbWithDocTypeOverlay} from "../app/SquareThumbWithDocTypeOverlay";
import {SearchResultDetailsProvider} from "../search-result-details/SearchResultDetailsContext";

export const InputRelatedOption = (data) => {
    return (
        <Stack direction="row"
               sx={{
                   minWidth: "100%",
                   border: 'solid 1px #ddd',
                   borderRadius: 2,
                   padding: '4px',
               }}
               spacing={1}>
            <SearchResultDetailsProvider>
                <SquareThumbWithDocTypeOverlay model={data}/>
            </SearchResultDetailsProvider>
            <Stack
                direction="column"
                sx={{
                    justifyContent: "center",
                    maxWidth: "300px"
                }}>
                <Typography variant="body1" color="textPrimary" noWrap>
                    {data.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" noWrap>
                    {data.description}
                </Typography>
                <Typography variant="caption" color="textSecondary" sx={{
                    mt: 1
                }}>
                    DAMS ID: {data.uniqueId}
                </Typography>
            </Stack>
        </Stack>
    );
};
